const system = {
  state: {
    menuIsCollapse: false
  },
  mutations: {
    SET_MENU_COLLAPSE (state, status) {
      state.menuIsCollapse = status
    }
  }
}

export default system



// WEBPACK FOOTER //
// ./src/store/modules/system.js